// extracted by mini-css-extract-plugin
export var extraContentContainer = "ReviewsSection-module--extraContentContainer--d9621";
export var lineHeightContent = "ReviewsSection-module--lineHeightContent--dba1f";
export var reviewsContainer = "ReviewsSection-module--reviewsContainer--cd36e";
export var reviewsContentContainer = "ReviewsSection-module--reviewsContentContainer--02569";
export var reviewsContentContainerMobile = "ReviewsSection-module--reviewsContentContainerMobile--b1e0c";
export var reviewsHeader = "ReviewsSection-module--reviewsHeader--b2f3b";